// import { SchemeTypes } from '../../../../config';
import { LanguagesEnum } from '../../../../config/languages';

const CONFIGURATION = {};

export const Translations = {
  header: {
    [LanguagesEnum.English]: 'Supplies from Member State of Identification',
    [LanguagesEnum.Greek]: 'Supplies from Member State of Identification',
  },
  add_supply: {
    [LanguagesEnum.English]: 'Add Supply',
    [LanguagesEnum.Greek]: 'Add Supply',
  },
};

export default CONFIGURATION;
